/**
 * Serializes class instances where required,
 * This is a stop-gap measure until we refactor some existing models to typescript interfaces
 * @param object
 */
export const serialize = (object: object) => (
    JSON.parse(JSON.stringify(object))
)